export const TestStatus = {
  Pending: 'pending',
  BloodRegistered: 'blood-registered',
  BloodworkDone: 'bloodwork-done',
  Completed: 'completed',
  Cancelled: 'cancelled',
};

export const TestImportStatus = {
  Initiated: 'initiated',
  Started: 'started',
  Completed: 'completed',
  NoImport: 'undefined',
};

export interface Test {
  id: number;
  orderId: number;
  productId: number;
  answerId?: number;
  administratorId?: number;
  status: string;
  completedAt?: string;

  remoteId?: string;
  remoteSampleId?: string;
  importStatus?: keyof typeof TestImportStatus;
  bloodLocationId?: number;
  isBloodRegistered: boolean;
  bloodRegistrationTime?: string;
  sampleReceivedAt?: string;
  lisCreated: boolean;

  commentResult?: string;
  commentSymptoms?: string;
  commentUnidentified?: string;

  allergensCount?: string;
  isAsit: boolean;
  resultsUrl?: string;
  pdfId?: string;

  result?: unknown;

  isAtHome: boolean;
  hasConsultation: boolean;
  hasExtendedInterpretation: boolean;

  createdAt: string;
  updatedAt: string;

  daysToDeadline?: number | null;
  hasPositiveResults?: boolean;
  questionnaireFilled?: boolean;

  productKey?: string;
  productTitle?: string;
  productIsFoodId?: boolean;
  administratorFirstName?: string;
  administratorLastName?: string;
  administratorImageKey?: string;
  locationName?: string;
  locationAddress?: string;
  locationPhone?: string;
  locationRegistrationUrl?: string;
  patientName?: string;
  patientLastName?: string;
  patientBirthDate?: string;
  patientAge?: number;
  patientIsChild?: boolean;
  patientHash?: string;

  orderEmail?: string;
  orderHash?: string;
  orderCreatedAt?: string;
  shopifyOrderId?: string;
  shopifyOrderNumber?: string;
  countryCode?: string;
}
